import React, { lazy, Suspense } from 'react';

import { Route, Switch } from 'react-router-dom';

import CodeRedactor from 'components/Layouts/Form/FormBuilder/Actions/CodeRedactor';
import { PreviewPage } from 'components/Pages/Admin/PreviewPage';
import ErrorScreen from 'components/shared/ErrorScreen';
import Loader from 'components/shared/Loader';
import {
  DASHBOARD_PATH,
  SETTINGS_PATH,
  PAGE_PATH,
  ITINERARIES_ITEM_STEP_PATH,
  CSS_REDACTOR_PATH,
  SAMPLE_PATH,
  PROPOSAL_PREVIEW_PATH,
} from 'constants/routes';
import { withPostHog } from 'integrations/posthog';
import { useUserGuiding } from 'integrations/userguiding';

import useFontAwesome from '../../../integrations/fontawesome/useFontAwesome';
import AccountFulfilledRoute from './AccountFulfilledRoute';
import DashboardRoutes from './AdminDashboard';
import ItinerariesItemRoute from './Itineraries';
import PageRoute from './Page';

const SettingsRoutes = lazy(() => import(/* webpackChunkName: "Settings" */ '../Settings'));
const ItinerariesItemRouteTracked = withPostHog(ItinerariesItemRoute);

function AdminRoutes() {
  useUserGuiding();
  useFontAwesome();

  return (
    <Switch>
      <AccountFulfilledRoute path={DASHBOARD_PATH} children={<DashboardRoutes />} />
      <Route
        path={SETTINGS_PATH}
        children={
          <Suspense fallback={<Loader />}>
            <SettingsRoutes />
          </Suspense>
        }
      />
      <AccountFulfilledRoute path={PAGE_PATH} children={<PageRoute />} />

      {/* PROPOSAL_PREVIEW should be above ITINERARIES_ITEM_STEP because of route intersection */}
      <AccountFulfilledRoute path={PROPOSAL_PREVIEW_PATH} children={<PreviewPage />} />
      <AccountFulfilledRoute path={ITINERARIES_ITEM_STEP_PATH} children={<ItinerariesItemRouteTracked />} />

      <AccountFulfilledRoute path={CSS_REDACTOR_PATH} children={<CodeRedactor />} />
      <AccountFulfilledRoute path={SAMPLE_PATH} children={<ItinerariesItemRoute />} />

      <Route render={() => <ErrorScreen status="404" />} />
    </Switch>
  );
}

export default AdminRoutes;
